import { useEffect, RefObject } from 'react';

type Props = {
  onClick?: () => void;
  ref: RefObject<HTMLDivElement | null>;
  targetRef?: RefObject<HTMLElement | null>;
};

export const useClickOutside = ({ onClick, ref, targetRef }: Props) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const targetNode = event.target as Node;
      const isOutsideTarget1 =
        !!ref.current && !ref.current.contains(targetNode);
      const isOutsideTarget2 =
        !!targetRef?.current && !targetRef.current.contains(targetNode);

      if (onClick) {
        // Close only when click is outside all tracked areas.
        if (targetRef?.current) {
          if (isOutsideTarget1 && isOutsideTarget2) {
            onClick();
          }
          return;
        }

        if (isOutsideTarget1) {
          onClick();
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClick, ref, targetRef]);
};
